import React from 'react';
import { getCompanyConfig } from '@/config/company';

export interface ISOPrintHeaderProps {
  config?: any;
  formCode?: string;
  issueNo?: string;
  issueDate?: string;
  pageStr?: string;
  className?: string;
}

/**
 * Standard Print Header Table
 * Reusable across print documents in APV ERP.
 * 
 * Column 1 (20%): Company Logo
 * Column 2 (80%): Legal Company Info, Tax Code, Address, Hotline
 */
export default function ISOPrintHeader({
  config,
  className = 'mb-4',
}: ISOPrintHeaderProps) {
  const c = getCompanyConfig(config);

  return (
    <table
      className={`w-full border-collapse ${className}`}
      style={{ border: '2px solid #000' }}
    >
      <tbody>
        <tr>
          {/* Col 1: Logo */}
          <td className="w-[20%] text-center align-middle border border-black p-2">
            {c.logoUrl ? (
              <img
                src={c.logoUrl}
                alt="Logo"
                className="max-h-[50px] mx-auto object-contain"
                onError={(e) => {
                  (e.target as HTMLImageElement).style.display = 'none';
                }}
              />
            ) : (
              <span className="font-bold text-[13px] uppercase tracking-wide">
                {c.companyName}
              </span>
            )}
          </td>

          {/* Col 2: Company Legal Details */}
          <td className="w-[80%] border border-black p-2 text-center align-middle">
            <div className="font-bold text-[13px] uppercase tracking-wide text-black">
              {c.companyName}
            </div>
            {c.companyNameEn && (
              <div className="text-[10px] text-slate-700 uppercase font-medium mt-0.5">
                {c.companyNameEn}
              </div>
            )}
            <div className="text-[10px] text-slate-800 mt-0.5">
              {c.address1 || c.address2}
            </div>
            <div className="text-[10px] text-slate-800 mt-0.5">
              MST: <span className="font-mono font-semibold">{c.taxCode}</span> | ĐT:{' '}
              {c.phone} | Email: {c.email}
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  );
}
